import styled from 'styled-components';


export const StyledStep = styled.div`
  /* padding: 10px 16px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* background-color: #2a2a2a; */

  .step-title {
    font-size: 32px;
    color: var(--blue);
    font-weight: bold;
    text-transform: capitalize;
  }

  .step-text {
    font-size: 14px;
    color: var(--grey-light);

    span {
        color: var(--green);
      }
  }

  .step-link {
    text-decoration: none;
    color: var(--grey-light);
    font-size: 12px;

    span {
      color: var(--green);
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/ReactTourSteps/ReactTourSteps.styles.tsx